import React, { Component } from 'react';
import { Spin, Col, Button, Icon, Modal, Form, Row, Select } from 'antd';
import { openNotification } from '../../util/notificaciones';
import CatalogoRequest from '../../services/Catalogo';
import moment from 'moment'
import 'moment/locale/es';
import ArticulosAuxiliaresRequest from '../../services/ArticulosAuxiliares';
moment.locale('es')
const { Option } = Select;
const { confirm } = Modal;

/**
 * Clase para ver el proceso de mostrar form de productos
 */
class FormArticulosAuxiliares extends Component {
    state = {
        cargando: false,
        bloquearBotones: false,
        cancelModalConfirm: false,
        arrRegiones: [],
        arrSucursales: [],
        arrPlazas: [],
        arrDrives: [],
        arrEstatus: [],
        regionSelected: null,
        sucursalSelected: null,
        plazaSelected: null,
        drivesSelected: [],
        arrCuentasGP: [],
        arrCuentasDrive: [],
        showCuentaRelacionada: false,
        obj_cuenta: null,
        textComboCuenta: "",
        account_type: undefined,
        drives_selected: this.props.drives_selected,
    }

    /**
     * Comportamiento del modal cada vez que se despliega.
     * Se aplica al editar o visualizar datos
     * @param: prevProps. propiedades que tenia el componente antes de ser
     * desplegado
     * @return: nada.
     */
    componentDidUpdate = (prevProps) => {
        if ((this.props.producto_selected !== prevProps.producto_selected)) {
            if (this.props.modo === "uno") {
                if (this.props.producto_selected) {
                    let state = { ...this.state };
                    const { setFieldsValue } = this.props.form
                    const cuenta = this.props.producto_selected?.cuenta[0]?.cuenta_contable;
                    state.drives_selected = this.props.producto_selected?.id_drive;
                    state.account_type = this.props.producto_selected?.es_costo === true ? 'costo' : 'gasto';
                    setFieldsValue({
                        cuenta_relacionada: cuenta,
                        informacion: cuenta
                    })
                    this.setState(state, this.cargarCuentasGP);
                }
            }
        }
    }

    /**
     * Función que se manda a llamar cuando se cierra el modal
     * de generar un pedido.
     */
    handleCancel = () => {
        this.props.esconderModal(false);
        this.props.form.resetFields();
        this.setState({
            regionSelected: null,
            sucursalSelected: null,
            plazaSelected: null,
            drivesSelected: [],
            showCuentaRelacionada: false,
            cargando: false,
            obj_cuenta: null,
            arrCuentasGP: [],
        })
    }

    /**
     * Función que se manda a llamar cuando quieren obtener las cuentas contables de GP
     */
    cargarCuentasGP = () => {
        let state = { ...this.state }
        let filtros = {}
        filtros.cuenta = state.textComboCuenta
        filtros.sitio_id = this.props.drives_selected ?? state.drives_selected;
        filtros.es_costo = state.account_type === 'costo' ? true : false;
        this.setState(state, () => {
            CatalogoRequest.ListarCuentasGP(filtros)
                .then(response => {
                    const data = response.data
                    this.setState({arrCuentasGP: data})
                }).catch(err => {
                    openNotification("Ha ocurrido un error al listar las cuentas contables.", false)
                })
        })
    }

    /**
     * Función que se manda a llamar cuando cambia el combo de cuenta
     */
    handleChangeCuenta = (value) => {
        let state = { ...this.state };
        const { setFieldsValue } = this.props.form

        setFieldsValue({
            cuenta_relacionada: null,
            informacion: ''
        })

        state.account_type = value;
        this.setState(state, this.cargarCuentasGP);
    }

    /**
     * Función que se manda a llamar cuando se busca el tipo de cuenta seleccionada
     */
    buscarCuentasCombo = (value) => {
        let state = { ...this.state };
        let buscar = false;
        if (value.trim() !== state.textComboCuenta.trim()) buscar = true
        state.textComboCuenta = value;
        this.setState(state);
        if (buscar) {
            clearTimeout(state.timer)
            state.timer = setTimeout(() => {
                this.cargarCuentasGP()
            }, 1000);
        }
    }

    /**
     * Función que se ejecuta cuando se confirma edición de estatus
     * @param: e. valor para prevent
     * @return: nada.
     */
    showConfirm = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                confirm({
                    title: 'Confirmar',
                    content: this.props.arrArticulos?.length === 1 ? <div><b>¿Está seguro de editar el artículo?</b> Se cambiará la información del artículo seleccionado.</div> : <div><b>¿Está seguro de editar el artículo?</b> Se cambiará la información de los artículos seleccionados.</div>,
                    okText: 'Aceptar',
                    cancelText: 'Cancelar',
                    okButtonProps: {
                        id: 'boton-aceptar-confirmacion-estatus-form',
                    },
                    cancelButtonProps: {
                        id: 'boton-cancelar-confirmacion-estatus-form',
                    },
                    onOk: () => {
                        this.setState({ cargando: true, bloquearBotones: true }, this.editarEstatusProductos)
                    },
                });
            }
        });
    }

    /**
     * Función que se cambia el estatus de los productos
     * @param: nada.
     * @return: nada.
     */
    editarEstatusProductos = () => {
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let state = { ...this.state }
                let objEnviar = {};
                let cuenta_contable = state.arrCuentasGP.filter(obj => obj.cuenta_contable === values.cuenta_relacionada);
                objEnviar.estatus = values.estatus === 1 ? true : false;
                objEnviar.drive_id = this.props.drives_selected;
                objEnviar.plaza_id = this.props.plaza_id;
                objEnviar.sucursal_id = this.props.sucursal_id;
                objEnviar.region_id = this.props.region_id;

                objEnviar.es_costo = values.cuenta_contable === 'costo' ? 1 : 0;
                objEnviar.cuenta = cuenta_contable[0];
                if (this.props.drives_selected.length === 1) {
                    objEnviar.articulos = this.props.modo === 'uno' ? [this.props.producto_selected.id] : this.props.arrArticulos.map(item => item.id)
                } else {
                    objEnviar.articulos = this.props.arrArticulos.map(item => item.id)
                }

                state.bloquearBotones = true;
                state.cargando = true;
                this.setState(state, () => {
                    ArticulosAuxiliaresRequest.EditarEstatusArticuloAuxiliar(objEnviar)
                        .then(response => {
                            state.cargando = false;
                            state.bloquearBotones = false
                            state.obj_cuenta = null;
                            state.arrCuentasGP = [];
                            this.props.form.resetFields();
                            this.setState(state, this.props.esconderModal(true, response.data))
                            openNotification(
                                response?.data?.cuerpo,
                                "Éxito",
                            )
                        })
                        .catch(err => {
                            this.setState({ bloquearBotones: false, cargando: false })
                            openNotification(
                                err?.response?.data?.cuerpo,
                                "Error",
                            )
                        })
                })
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        let arrCuentasGP = this.state.arrCuentasGP ?? [];
        return (
            <div>
                <Modal
                    title={"Editar información de artículos"}
                    onCancel={this.handleCancel}
                    visible={this.props.visible}
                    onOk={this.showConfirm}
                    width={"30%"}
                    maskClosable={false}
                    centered={true}
                    footer={
                        [
                            <Button
                                id="boton-regresar-form-estatus-productos"
                                className="btnCancelar"
                                key="back"
                                onClick={this.handleCancel}>
                                Regresar
                            </Button>,
                            <Button
                                className={this.props.modo !== "ver" ? 'btnVerCrearGuardar' : 'display-none'}
                                key="submit"
                                id="boton-guardar-form-estatus-productos"
                                type="primary"
                                disabled={this.state.bloquearBotones}
                                onClick={this.showConfirm}
                            >
                                Guardar
                            </Button>,
                        ]
                    }
                >
                    <Spin
                        tip="Cargando..."
                        indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                        spinning={this.state.cargando}
                        style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}>
                        <Form onSubmit={this.showConfirm}>
                            <Row gutter={12}>
                                <Col span={24}>
                                    <Form.Item
                                        label={"Estatus"}
                                        colon
                                    >
                                        {getFieldDecorator('estatus', {
                                            rules: [
                                                { required: true, message: 'Por favor, seleccione un estatus.' },
                                            ],
                                            initialValue: (this.props.arrArticulos.length > 1 ? null :
                                                this.props.producto_selected?.estatus === true ? 1 : 2)
                                        })(
                                            <Select
                                                id="select-estatus-form-productos"
                                                showSearch
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                                onChange={this.handleChangeEstatus}
                                                allowClear
                                            >
                                                <Option value={null} disabled={true}>Seleccionar...</Option>
                                                <Option value={1} key={1}>Activo</Option>
                                                <Option value={2} key={2}>Inactivo</Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={"Cuenta contable"}
                                        colon
                                    >
                                        {getFieldDecorator('cuenta_contable', {
                                            rules: [
                                                { required: true, message: 'Por favor, seleccione una cuenta contable.' },
                                            ],
                                            initialValue: (this.props.producto_selected?.configurado === false ? null :
                                                this.props.producto_selected?.es_costo === true ? 'costo' :
                                                    this.props.producto_selected?.es_costo === false ? 'gasto' : null)
                                        })(
                                            <Select
                                                id="select-cuenta-contable-form-productos"
                                                showSearch
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                optionFilterProp="children"
                                                onChange={this.handleChangeCuenta}
                                                allowClear
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                <Option value={'costo'} key={1}>Costo</Option>
                                                <Option value={'gasto'} key={2}>Gasto</Option>
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                                <Col span={24}>
                                    <Form.Item
                                        label={"Cuenta relacionada"}
                                        colon
                                    >
                                        {getFieldDecorator('cuenta_relacionada', {
                                            rules: [
                                                { required: true, message: 'Por favor, seleccione una cuenta relacionada.' },
                                            ],
                                            initialValue: null
                                        })(
                                            <Select
                                                id="select-cuenta-relacionada-form-productos"
                                                showSearch
                                                style={{ width: "100%" }}
                                                defaultActiveFirstOption={false}
                                                notFoundContent='No hay opciones'
                                                placeholder="Seleccionar..."
                                                filterOption={false}
                                                allowClear
                                                onSearch={(value) => {
                                                    this.buscarCuentasCombo(value)
                                                }}
                                                onChange={(value) => {
                                                    let state = {...this.state}
                                                    const cuenta = state.arrCuentasGP.filter(obj => obj.cuenta_contable === value)
                                                    const obj_cuenta = cuenta[0];
                                                    const { setFieldsValue } = this.props.form
                                                    if (cuenta.length) {
                                                        setFieldsValue({
                                                            informacion: obj_cuenta.ACTNUMST
                                                        })
                                                    }
                                                    this.setState({ obj_cuenta: obj_cuenta })
                                                }}
                                            >
                                                <Option key={0} value={null} disabled={true}>Seleccionar...</Option>
                                                {
                                                    arrCuentasGP.length &&
                                                    arrCuentasGP.map(obj => {
                                                        return (
                                                            <Option
                                                                key={obj.ACTNUMST}
                                                                value={obj.cuenta_contable}>
                                                                {obj.cuenta_contable}
                                                            </Option>
                                                        )
                                                    })
                                                }
                                            </Select>
                                        )}
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Spin>
                </Modal>
            </div >
        )
    }
}

export default Form.create()(FormArticulosAuxiliares);